import { bootstrapApplication } from '@angular/platform-browser';
import { isDevMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Disable all console logs and errors in production mode or on non-localhost domains
if (!isDevMode() || (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1')) {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
}

bootstrapApplication(App, appConfig)
  .catch(err => {
    if (isDevMode()) {
      console.error('Application bootstrap failed:', err);
    }
  });
